import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Toast } from './toast.interface';

@Component({
  selector: 'app-toaster',
  template: `
    <div class="media toast toast-{{toast.type}}" 
      [style.bottom.px]="i*100">
      <!--<img src="../../assets/img/small-logo.png" alt="Profile Image" class="toaster-logo" />-->

      <div class="media-body toaster-content">
<div class="toast-icon"><i class="fa fa-info-circle"></i></div>
      <h4 class="toast-heading">{{toast.title}}</h4>
      <p>{{toast.body}}</p>
      <a class="close" (click)="remove.emit(i)">&times;</a>
      </div>
    </div>
  `,
  styles: [`
  
    .toast {
      position: fixed;
      z-index:9999;
      right: 15px;
      margin-bottom:20px;
      width: 300px;
      height: 80px;
      padding: 10px;
      margin-top: 1rem;
      border: 1px solid transparent;
      border-radius: 0 .25rem .25rem 0;
      animation: move 2s both;
      opacity:1!important;
      display:inline-table;
    }


    .toast-success {
      color: #333;
     /* background-color: #d4edda;*/
background-color: #fff;
      border-left: 5px solid #03cc03;
    }

    .toast-error {
      color: #333;
      /*background-color: #f8d7da;*/
background-color: #fff;
      border-left: 5px solid #fc0303;
    }

    .toast-warning {
      color: #333;
     /* background-color: #fff3cd;*/
background-color: #fff;
      border-left: 5px solid #fbbe02;
    }

    .close {
      position: absolute;
      top: -5px;
      right: 5px;
      font-size: 1.5em;
      cursor: pointer;
    }

    .toast-heading {
      margin-top: 10px;
    }
    .toaster-logo {
        float: left;
        width: 40px;
        margin-right: 10px;
        margin-top: 10px;
        background: #fff;
        padding: 3px;
        border-radius: 5px;
    }
    .toaster-content {
        
        padding-left: 30px;
padding-right:10px;
        /*float:left;*/
position:relative;
font-size:16px;
    }
.toast-icon {
position:absolute;
left:0;
top:0;
}
.toast-icon i {
font-size:20px;
color:#333;
}

    @keyframes move {
      from {
        transform: translateX(100%);
      }
      to {
        transform: translateX(0);
      }
  `]
})
export class ToasterComponent {
  @Input() toast: Toast;
  @Input() i: number;

  @Output() remove = new EventEmitter<number>();
}
